// Service worker registration.
// Dispatches a custom event when a new version is ready so the app can
// show a "Reload to update" prompt. The SwUpdatePrompt component listens
// for `caro:sw-update-available` and surfaces a notistack snackbar.

const UPDATE_EVENT = 'caro:sw-update-available';

const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        // If there's already a waiting worker (e.g. user closed the tab
        // mid-update), surface the prompt immediately.
        if (registration.waiting && navigator.serviceWorker.controller) {
          window.dispatchEvent(new CustomEvent(UPDATE_EVENT, {
            detail: { registration },
          }));
        }

        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // New content available — announce and let the React layer decide.
                window.dispatchEvent(new CustomEvent(UPDATE_EVENT, {
                  detail: { registration },
                }));
              } else {
                // First install — content cached for offline.
                // No prompt; SW is now ready to serve the app offline.
              }
            }
          };
        };

        // Re-check once an hour so long-lived tabs pick up updates.
        setInterval(() => {
          registration.update().catch(() => { /* ignore */ });
        }, 60 * 60 * 1000);
      })
      .catch((error) => {
        console.error('ServiceWorker registration failed:', error);
      });

    // When the controller changes (because we activated a waiting SW),
    // reload once so the new assets are in use. Guard against reload loops
    // by tracking whether we've reloaded already.
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
};

export default registerServiceWorker;
